<template>
  <WdsStack
    direction-row
    gap-sm
    :class="{ 'loading-container-bg': !noBg, 'loading-container': true }"
  >
    <Skeleton v-if="avatar" class="loading-square" />

    <WdsStack direction-column gap-sm class="tw-flex-1">
      <Skeleton :class="{ loading: true, 'loading-title': title }" />

      <Skeleton v-if="!title" class="loading-secondary" />
    </WdsStack>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack } from '@worksome/wds-components'

import Skeleton from './Skeleton.vue'

withDefaults(defineProps<{ avatar?: boolean; noBg?: boolean; title?: boolean }>(), {
  avatar: false,
  title: false,
  noBg: false,
})
</script>

<style lang="scss" scoped>
.loading-container {
  @apply tw-w-full;
  @apply tw-rounded;
  @apply tw-py-1;
  @apply tw-p-3;
  @apply tw-flex;
  @apply tw-items-center;
}

.loading-container-bg {
  @apply tw-bg-white;
  @apply tw-px-4;
  @apply tw-mt-2;
}

.loading-square {
  @apply tw-w-[46px];
  @apply tw-h-[46px];
  @apply tw-rounded-lg;
}

.loading {
  @apply tw-w-3/5;
  @apply tw-h-[20px];
  @apply tw-rounded-xl;
}

.loading-title {
  @apply tw-h-[30px];
}

.loading-secondary {
  @apply tw-w-2/5;
  @apply tw-h-[20px];
  @apply tw-bg-gray-100;
  @apply tw-rounded-xl;
}
</style>
